export default __webpack_public_path__ + "static/media/treyd_square_logo_blue.2dfdb1eb.svg";